<template>
    <div>
        <div v-if="sectionData.tags && sectionData.tags.length" class="tags">
            <span v-for="(tag, index) in sectionData.tags" :key="index" class="tag">
                {{ tag }}
            </span>
        </div>

        <div v-if="sectionData.materials && sectionData.materials.length">
            <div v-for="(material, idx) in sectionData.materials" :key="idx" class="material">
                <div class="material-header">
                    <div class="material-id">ID материала: {{ material.material_id }}</div>
                    <div class="material-chance">Вероятность: {{ material.chance }}%</div>
                </div>

                <div v-if="material.tags && material.tags.length" class="tags">
                    <span v-for="(tag, index) in material.tags" :key="index" class="tag">
                        {{ tag }}
                    </span>
                </div>

                <div v-if="material.preview" class="previews">
                    <img
                        v-if="material.preview.plane"
                        :src="material.preview.plane"
                        alt="Plane preview"
                    />
                    <img
                        v-if="material.preview.sphere"
                        :src="material.preview.sphere"
                        alt="Sphere preview"
                    />
                </div>
            </div>
        </div>
        <div v-else>Материалы отсутствуют</div>
    </div>
</template>

<script>
    export default {
        props: {
            sectionData: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>
    .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 15px;
    }

    .tag {
        background: #e0e8ff;
        color: var(--primary-color);
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
    }

    .material {
        margin-bottom: 15px;
        padding: 12px;
        background: #f8faff;
        border-radius: 8px;
    }

    .material-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    .material-id {
        font-weight: 600;
        color: var(--text-dark);
    }

    .material-chance {
        color: var(--text-light);
    }

    .previews {
        display: flex;
        gap: 10px;
        margin: 10px 0;
    }

    .previews img {
        max-width: 80px;
        border-radius: 6px;
        border: 1px solid var(--border-color);
    }

    @media (max-width: 480px) {
        .material-header {
            flex-direction: column;
            gap: 5px;
        }

        .previews {
            flex-direction: column;
            align-items: center;
        }

        .previews img {
            max-width: 100%;
        }
    }
</style>
